import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * GetConversation
 *
 * @private
 */
export const getConversation = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.routingAssistant.GetConversationResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.routingAssistant.GetConversationAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/routing-assistant/getConversation', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/routing-assistant/getConversation', {
      category: 'rpc',
      type: 'rpc/routing-assistant/getConversation',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on getConversation`,
      { tags: ['rpc', 'routing-assistant'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `getConversation call failed`,
      error,
    })
  }
})
